import React, { Component } from "react";
import { MDBMask, MDBRow, MDBCol, MDBView, MDBContainer } from "mdbreact";
import { FacebookLoginButton, GoogleLoginButton, GithubLoginButton } from 'react-social-login-buttons'

import "./style.css";
import { auth, google, facebook, github } from '../../firebase/config'

import { connect } from 'react-redux'
import changeStatus from '../../actions/userStatus'


class AppPage extends Component {
    componentDidMount() {
        let self = this
        auth.onAuthStateChanged(user => {
            if (user) {
                let name = user.email || user.displayName
                localStorage.setItem('uid', user.uid)
                self.props.changeUser(true, user.uid, name)
                this.props.history.push('/main')
            }
            else {
                self.props.changeUser(false)
            }
        })
    }

    onClickGoogle = () => {
        auth.signInWithPopup(google)
            .then(data => {
            })
            .catch(err => {
                alert('err while sign in')
                console.log(err)
            })
    }
    onClickFacebook = () => {
        auth.signInWithPopup(facebook)
            .then(data => {
            })
            .catch(err => {
                alert('err while sign in')
                console.log(err)
            })
    }
    onClickGithub = () => {
        auth.signInWithPopup(github)
            .then(data => {
            })
            .catch(err => {
                alert('err while sign in')
                console.log(err)
            })
    }

    signOut = () => {
        auth.signOut()
    }

    render() {
        console.log(this.props)
        return (
            <div id="apppage">
                <MDBView>
                    <MDBMask className="d-flex justify-content-center align-items-center gradient">
                        <MDBContainer>
                            <MDBRow>
                                <div className="white-text text-center text-md-left col-md-6 mt-xl-5 mb-5">
                                <div className="justify-content-center d-flex">

                                <img style={{minHeight:'100px'}}  src="https://dewey.tailorbrands.com/production/brand_version_mockup_image/570/1636416570_c005ae40-bc2c-42ec-9f8f-04402cdd063b.png?cb=1548832092" alt=""/>
                                </div>
                                    <h1 className="h1-responsive font-weight-bold mt-sm-5">
                                        Safe, Reliable, and Simple{" "}
                                    </h1>
                                    <hr className="hr-light" />
                                    <h6 className="mb-4">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Rem repellendus quasi fuga nesciunt dolorum nulla magnam
                                        veniam sapiente, fugiat! Commodi sequi non animi ea dolor
                                        molestiae iste.
                                    </h6>
                                    <p> Let me in with:</p>

                                    <div className="col-md-7 m-0 p-0">
                                        <GithubLoginButton onClick={this.onClickGithub} />
                                        <FacebookLoginButton onClick={this.onClickFacebook} />
                                        <GoogleLoginButton onClick={this.onClickGoogle} />
                                    </div>

                                </div>
                                <MDBCol md="6" xl="5" className="mt-xl-5">
                                    <img
                                        src="https://mdbootstrap.com/img/Mockups/Transparent/Small/admin-new.png"
                                        alt=""
                                        className="img-fluid"
                                    />
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBMask>
                </MDBView>


            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return (
        {
            user: state.userStatus
        }
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeUser: (data, uid, name) => dispatch(changeStatus(data, uid, name))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AppPage);